import {Injectable} from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import {Observable} from "rxjs";
import {switchMap, take} from "rxjs/operators";
import {AuthService} from "src/app/modules/auth/services/auth.service";

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  constructor(private readonly authService: AuthService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (req.url.endsWith("/refresh_token")) {
      return next.handle(req);
    }

    return this.authService.tokens$.pipe(
      take(1),
      switchMap((tokens) => {
        if (tokens) {
          const headers: Record<string, string> = {
            Authorization: `Bearer ${tokens.accessToken}`,
          };

          const clonedReq = req.clone({
            setHeaders: headers,
          });
          return next.handle(clonedReq);
        } else {
          return next.handle(req);
        }
      })
    );
  }
}
